import dynamic from 'next/dynamic';

export default dynamic(
  () => import(/* webpackChunkName: "NotFound.components" */'./NotFound.component'),
  { loading: () => null }
);
